import { useState, useRef } from 'react'
import { createPortal } from 'react-dom'
import { useAuth } from '../contexts/AuthContext'
import api from '../services/api'

const PRIMARY = 'var(--primary)'

// Reduz a foto pra um thumbnail (max 240x240, JPEG) antes de mandar pro back — ela viaja junto
// com /auth/me em toda troca de tela, entao precisa ser pequena.
function redimensionarImagem(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onerror = reject
    reader.onload = (ev) => {
      const img = new Image()
      img.onerror = reject
      img.onload = () => {
        const tamanho = 240
        const lado = Math.min(img.width, img.height)
        const canvas = document.createElement('canvas')
        canvas.width = tamanho
        canvas.height = tamanho
        const ctx = canvas.getContext('2d')
        ctx.drawImage(
          img,
          (img.width - lado) / 2, (img.height - lado) / 2, lado, lado,
          0, 0, tamanho, tamanho
        )
        resolve(canvas.toDataURL('image/jpeg', 0.85))
      }
      img.src = ev.target.result
    }
    reader.readAsDataURL(file)
  })
}

export default function PerfilModal({ onClose }) {
  const { usuario, refreshUsuario } = useAuth()
  const [form, setForm] = useState({
    nome: usuario?.nome || '',
    email: usuario?.email || '',
    telefone: usuario?.telefone || '',
    data_nascimento: usuario?.data_nascimento?.split('T')[0] || '',
    foto: usuario?.foto || null,
  })
  const [loading, setLoading] = useState(false)
  const [erro, setErro] = useState('')
  const inputFotoRef = useRef(null)

  const escolherFoto = async (e) => {
    const file = e.target.files?.[0]
    if (!file) return
    try {
      const dataUrl = await redimensionarImagem(file)
      setForm(f => ({ ...f, foto: dataUrl }))
    } catch {
      setErro('Não foi possível ler essa imagem')
    }
  }

  const salvar = async (e) => {
    e.preventDefault()
    setLoading(true)
    setErro('')
    try {
      await api.put('/auth/perfil', form)
      await refreshUsuario()
      onClose()
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao salvar perfil')
    } finally {
      setLoading(false)
    }
  }

  // Renderiza direto em document.body: a Navbar usa backdrop-filter (blur), que no CSS cria um
  // "containing block" novo pra descendentes com position:fixed — sem o portal, esse modal ficava
  // preso dentro da caixa da Navbar em vez de centralizar na tela inteira.
  return createPortal(
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      onClick={e => { if (e.target === e.currentTarget) onClose() }}>
      <div className="card" style={{ width: 420, maxWidth: '95vw' }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: PRIMARY, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 14 }}>
          Meu Perfil
        </div>
        {erro && <div className="alert alert-error" style={{ marginBottom: 10 }}>{erro}</div>}
        <form onSubmit={salvar} style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 4 }}>
            <button type="button" onClick={() => inputFotoRef.current?.click()}
              style={{
                width: 84, height: 84, borderRadius: '50%', border: `2px dashed rgba(var(--primary-rgb),0.35)`,
                background: form.foto ? `url(${form.foto}) center/cover` : 'rgba(var(--primary-rgb),0.06)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                cursor: 'pointer', fontSize: 11, color: PRIMARY, fontWeight: 600, textAlign: 'center',
                whiteSpace: 'pre-line', lineHeight: 1.3,
              }}
            >
              {!form.foto && 'Adicionar\nfoto'}
            </button>
            <input ref={inputFotoRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={escolherFoto} />
          </div>
          <div className="form-group" style={{ margin: 0 }}>
            <label className="form-label">Nome *</label>
            <input className="form-input" value={form.nome} onChange={e => setForm({ ...form, nome: e.target.value })} required />
          </div>
          <div className="form-group" style={{ margin: 0 }}>
            <label className="form-label">Email *</label>
            <input className="form-input" type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required />
          </div>
          <div className="form-group" style={{ margin: 0 }}>
            <label className="form-label">Telefone</label>
            <input className="form-input" value={form.telefone} onChange={e => setForm({ ...form, telefone: e.target.value })} />
          </div>
          <div className="form-group" style={{ margin: 0 }}>
            <label className="form-label">Aniversário</label>
            <input className="form-input" type="date" value={form.data_nascimento} onChange={e => setForm({ ...form, data_nascimento: e.target.value })} />
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
            <button className="btn btn-primary" type="submit" style={{ flex: 1 }} disabled={loading}>{loading ? 'Salvando...' : 'Salvar'}</button>
            <button className="btn" type="button" onClick={onClose} style={{ flex: 1, background: '#eee', color: '#333' }}>Cancelar</button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  )
}
